module.exports = __webpack_public_path__ + "img/loader.45b05aaa.svg";